export { default as StandardTableScreen } from './StandardTableScreen';
